import { render, staticRenderFns } from "./BudgetDashboardDepartmentSelector.vue?vue&type=template&id=feee48ae&scoped=true&"
import script from "./BudgetDashboardDepartmentSelector.vue?vue&type=script&lang=js&"
export * from "./BudgetDashboardDepartmentSelector.vue?vue&type=script&lang=js&"
import style0 from "./BudgetDashboardDepartmentSelector.vue?vue&type=style&index=0&id=feee48ae&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feee48ae",
  null
  
)

export default component.exports